// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep table.table-rfq-list th {
  padding: 1rem 0.25rem 1rem 0.5rem !important;
  font-size: smaller;
  border-width: 1px !important;
}
::ng-deep table.table-rfq-list td {
  padding: 0.25rem 0.5rem !important;
  font-size: smaller;
}
::ng-deep table.table-rfq-list td a {
  color: var(--primary-light);
  text-decoration: none;
}
::ng-deep table.table-rfq-list td a:hover {
  color: var(--primary-light);
  text-decoration: underline;
}
::ng-deep table.table-rfq-list td a:visited {
  color: var(--primary-light);
}`, "",{"version":3,"sources":["webpack://./src/app/secure/dashboard/rfqs/rfqs.component.scss"],"names":[],"mappings":"AAEQ;EACI,4CAAA;EACA,kBAAA;EACA,4BAAA;AADZ;AAGQ;EACI,kCAAA;EACA,kBAAA;AADZ;AAGY;EACI,2BAAA;EACA,qBAAA;AADhB;AAEgB;EACI,2BAAA;EACA,0BAAA;AAApB;AAEgB;EACI,2BAAA;AAApB","sourcesContent":["::ng-deep table {\n    &.table-rfq-list {\n        th {\n            padding: 1rem 0.25rem 1rem 0.5rem !important;\n            font-size: smaller;\n            border-width: 1px !important;\n        }\n        td {\n            padding: 0.25rem 0.5rem !important;\n            font-size: smaller;\n\n            a {\n                color: var(--primary-light);\n                text-decoration: none;\n                &:hover {\n                    color: var(--primary-light);\n                    text-decoration: underline;\n                }\n                &:visited {\n                    color: var(--primary-light);\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
